import FieldLoader from "../Atom/FieldLoader";

export default function LoadingPage() {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      loading ...
      <FieldLoader />
    </div>
  );
}
